import axios from 'axios';
//axios 전역설정하는곳
const instance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL || 'https://localhost:443',
});
instance.defaults.headers.post['Content-Type'] = 'application/json';
export default instance;
